enum CurrencySymbol {
    /**
     * U.S. Dollar - $
     */
    USD = '$',
    /**
     * Canadian Dollar - CA$
     */
    CAD = 'CA$',
    /**
     * Euro - €
     */
    EUR = '€',
    /**
     * Hong Kong Dollar - HK$
     */
    HKD = 'HK$',
    /**
     * Philippine peso - ₱
     */
    PHP = '₱',
}

export default CurrencySymbol;
